export const isEnvDevelopment = () => {
    return process.env.NODE_ENV === "development";
};